import { useAtomValue } from "jotai";
import {
  LoggedUserId,
  SeletectedDoctorState,
} from "../../main/state/globalState";
import { trpc } from "../../main/components/trpc.ts";

export default function useOwner() {
  return useOwnerState().owner;
}

export function useOwnerState() {
  const userId = useAtomValue(LoggedUserId);
  const userQuery = trpc.user.getMyself.useQuery(undefined, {
    enabled: !!userId,
  });
  const selectedDoctorId = useAtomValue(SeletectedDoctorState);

  return {
    owner: getOwnerFromUser(userQuery.data || null, selectedDoctorId),
    isLoading: userQuery.isPending,
    error: userQuery.error,
  };
}

export const getOwnerFromUser = (
  user: { tag: "doctor" | "secretary" | "app"; id: string } | null,
  selectedDoctorId: string | null,
) => {
  if (!user) {
    return null;
  }
  if (user.tag === "secretary") {
    return selectedDoctorId;
  }
  if (user.tag === "doctor") {
    return user.id;
  }
  return null;
};
